<template>
  <Scaffold :loading="loading || loadingCurrentProjet" :identity="identity" :showMenu="showMenu">
    <template #topbar>
      <div class="project-topbar" v-if="authenticated">
        <div>
          <router-link :to="{ name: 'my-projects' }" class="my-projects-link"><LeftArrow /> My projects</router-link>
        </div>
        <div v-if="!loadingCurrentProjet && project" class="project-details">
          <ProjectStatusSelect
            :statuses="statuses"
            :value="project.status"
            :disabled="!isProjectManager"
            class="project-status-select"
            @input="handleProjectStatusChange"
          />
          <div class="project-info">
            <slot name="project-name">

            <p class="project-name">{{ project.name }}</p>
            </slot>
            <p class="project-properties">
              {{ formatBrands(project.brands) }}
              <span v-if="project.dueDate"> &ndash; due {{ formatDueDate(project.dueDate) }}</span>
            </p>
          </div>
          <UserPicker
            :can-add="isProjectManager"
            :options="users"
            :value="project.users"
            @input="handleProjectUsersChange"
          />
          <ts-button
            v-if="isProjectManager"
            type="primary"
            size="small"
            circle
            class="edit-button"
            @click="handleEditClick"
          >
            <ts-icon icon="pen" size="x-small" color="#6d7587" title="Edit" />
          </ts-button>
        </div>
      </div>
      <div class="project-topbar" v-else>
        <div v-if="!error && project" class="project-details">
          <ProjectStatusSelect v-if="metadata" :value="project.status" :disabled="true" class="project-status-select" />
          <div class="project-info">
            <slot name="project-name">

            <p class="project-name">{{ project.name }}</p>
            </slot>
            <slot name="project-properties">

            <p class="project-properties" v-if="metadata">
              {{ formatBrands(project.brands) }}
              <span v-if="project.dueDate"> &ndash; due {{ formatDueDate(project.dueDate) }}</span>
            </p>
            </slot>
          </div>
        </div>
      </div>
    </template>
    <div class="content">
      <slot></slot>
    </div>
  </Scaffold>
</template>

<style lang="scss" scoped>
.project-topbar {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 26px;
}

.project-details {
  height: 100%;
  display: flex;
  align-items: center;
  flex-grow: 1;
}

.my-projects-link {
  font-family: Roboto;
  font-size: 16px;
  color: #6d7587;
  text-decoration: none;
}

.project-status-select {
  margin-left: 100px;
}

.project-info {
  margin-left: 24px;
  flex-grow: 1;

  .project-name {
    font-family: Roboto;
    font-size: 20px;
    color: #6d7587;
  }

  .project-properties {
    font-family: Roboto;
    font-size: 12px;
    line-height: 1.5;
    color: #6d7587;
  }
}

.edit-button {
  margin-left: 60px;
}

.content {
  padding: 24px 40px;
  min-height: 100%;
}
</style>

<script>
import { mapState, mapActions } from 'vuex';

import Scaffold from '@/components/layouts/Scaffold.vue';
import ProjectStatusSelect from '@/components/inputs/ProjectStatusSelect.vue';
import UserPicker from '@/components/inputs/UserPicker.vue';

import projectViewHelpers from '@/mixins/projectViewHelpers';

import LeftArrow from '@/assets/left-arrow.svg';

export default {
  mixins: [projectViewHelpers],
  components: {
    Scaffold,
    ProjectStatusSelect,
    UserPicker,
    LeftArrow
  },
  props: {
    showMenu: {
      type: Boolean,
      default: true
    },
    identity: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    metadata: {
      type: Boolean,
      default: true
    },
    authenticated: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState('workflow', {
      loadingCurrentProjet: state => state.currentProject.loading,
      currentProjetError: state => state.currentProject.error,
      error: state => state.currentProject.error,
      project: state => state.currentProject.value,
      statuses: state => state.statuses.items,
      users: state => state.users.items,
      usersError: state => state.users.error,
      brandsError: state => state.brands.error
    })
  },
  methods: {
    ...mapActions('workflow', ['fetchUsers', 'fetchProject', 'updateProjectStatus', 'updateProjectUsers']),
    handleProjectStatusChange(value) {
      this.updateProjectStatus({ project: this.project, value });
    },
    handleProjectUsersChange(value) {
      this.updateProjectUsers({ project: this.project, value });
    },
    handleEditClick() {
      this.$router.push({ name: 'project-details-general-info', params: { projectId: this.project.id } });
    }
  },
  mounted() {
    if (!this.authenticated) return;
    this.fetchUsers();
    this.fetchProject({ projectId: this.$route.params.projectId });
  },
  watch: {
    usersError(value) {
      if (value) {
        this.showError(value);
      }
    },
    brandsError(value) {
      if (value) {
        this.showError(value);
      }
    },
    currentProjetError(value) {
      if (value) {
        this.showError(value);
      }
    }
  }
};
</script>
